"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsDeltaApi = void 0;
const core_1 = require("../../core");
const translationsWebStorage_1 = require("../translationsStorage/translationsWebStorage");
const translationsVersion_1 = require("../translationsVersion");
const translationsApi_1 = require("./translationsApi");
const LOG_PREFIX = '[Api delta translations]';
/**
 * Extracts translation data from the API response.
 * @param data - The API response containing translation data.
 * @returns A structured `TranslationsType` object or `undefined` if data is invalid.
 */
const getTranslationsDataType = (data) => {
    return data
        ? {
            entries: data.entries,
            language: data.language,
            version: data.version,
        }
        : undefined;
};
/**
 * Extracts the version information from the API response.
 * @param param0 - The API response containing version information.
 * @returns An object containing the language and version.
 */
const getVersion = ({ language, packageVersion }) => {
    return {
        language,
        version: packageVersion,
    };
};
/**
 * Handles downloading and merging translations from the API.
 */
class TranslationsDeltaApi extends translationsApi_1.TranslationsApi {
    constructor(params) {
        super(params);
    }
    /**
     * Fetches translations from the API, either merging with existing translations (if deltaUrl is used)
     * or replacing them entirely (if downloadUrl is used).
     * @param currentVersion - The current version of translations.
     * @param forced - Whether to force the download even if the version matches.
     * @returns The updated translations or `undefined` if no update is needed.
     */
    get(currentVersion_1) {
        return __awaiter(this, arguments, void 0, function* (currentVersion, forced = false) {
            var _a;
            try {
                const requestUrl = this.getDownloadUrl(currentVersion);
                const { data: versionData } = yield this.xhr.GET(requestUrl);
                const urlRaw = (_a = versionData === null || versionData === void 0 ? void 0 : versionData.deltaUrl) !== null && _a !== void 0 ? _a : versionData.downloadUrl;
                if (translationsVersion_1.TranslationsVersion.isEqual(currentVersion, getVersion(versionData)) && !forced) {
                    core_1.Log.info(`${LOG_PREFIX} - Current version matches the latest version on the API.`);
                    return Promise.resolve(undefined);
                }
                try {
                    const { data: translationsResponse } = yield this.xhr.GET(urlRaw);
                    core_1.Log.info(`${LOG_PREFIX} - Successfully downloaded translations.`);
                    const newTranslations = getTranslationsDataType(translationsResponse);
                    if (versionData === null || versionData === void 0 ? void 0 : versionData.deltaUrl) {
                        const existingTranslations = yield this.getExistingTranslations();
                        return this.mergeTranslations(existingTranslations, newTranslations);
                    }
                    return Promise.resolve(newTranslations);
                }
                catch (error) {
                    core_1.Log.warn(`${LOG_PREFIX} - Failed to download translations package.`);
                    return Promise.reject(error);
                }
            }
            catch (error) {
                core_1.Log.warn(`${LOG_PREFIX} - Failed to retrieve translations URL.`);
                return Promise.reject(error);
            }
        });
    }
    /**
     * Merges existing translations with new translations.
     * @param existing - The existing translations.
     * @param newTranslations - The new translations to merge.
     * @returns The merged translations.
     */
    mergeTranslations(existing, newTranslations) {
        if (!existing) {
            return newTranslations;
        }
        if (!newTranslations) {
            return existing;
        }
        return Object.assign(Object.assign({}, existing), { entries: Object.assign(Object.assign({}, existing.entries), newTranslations.entries) });
    }
    /**
     * Retrieves existing translations from storage.
     * @returns The existing translations or `undefined` if none are found.
     */
    getExistingTranslations() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const storage = new translationsWebStorage_1.TranslationsWebStorage({ platform: 'WEB' });
                const existingTranslations = yield storage.get();
                if (existingTranslations) {
                    core_1.Log.info(`${LOG_PREFIX} - Retrieved existing translations from storage.`);
                }
                else {
                    core_1.Log.info(`${LOG_PREFIX} - No existing translations found in storage.`);
                }
                return existingTranslations;
            }
            catch (error) {
                core_1.Log.warn(`${LOG_PREFIX} - Error retrieving existing translations from storage.`);
                return undefined;
            }
        });
    }
}
exports.TranslationsDeltaApi = TranslationsDeltaApi;
//# sourceMappingURL=translationsDeltaApi.js.map